import { createSlice } from '@reduxjs/toolkit'

const qnaInitialDataSlice = createSlice({
  name: 'qnaInitialData',
  initialState: null,
  reducers: {
    setInitialQnAData: (state, action) => action.payload,
    clearInitialQnAData: () => null,
  },
})

export const { setInitialQnAData, clearInitialQnAData } = qnaInitialDataSlice.actions
export default qnaInitialDataSlice.reducer 